function getOrderOnlineLink(title) {
  const linkMap = {
    "leopolds-tavern-edmonton-winterburn": "https://iorders-restaurant-online-dev.pages.dev/leopolds-tavern-edmonton-winterburn/",
    "leopolds-tavern-edmonton-strathcona": "https://iorders-restaurant-online-dev.pages.dev/leopolds-tavern-edmonton-strathcona/",
    "leopolds-tavern-saskatoon-evergreen": "https://iorders-restaurant-online-dev.pages.dev/leopolds-tavern-saskatoon-evergreen/",
    "leopolds-tavern-saskatoon-broadway": "https://iorders-restaurant-online-dev.pages.dev/leopolds-tavern-saskatoon-broadway/",
    "leopolds-tavern-calgary-sage-hill": "https://iorders-restaurant-online-dev.pages.dev/leopolds-tavern-calgary-sage-hill/",
    "leopolds-tavern-calgary-bowness": "https://iorders-restaurant-online-dev.pages.dev/leopolds-tavern-calgary-bowness/",
    "leopolds-tavern-regina-north": "https://iorders-restaurant-online-dev.pages.dev/leopolds-tavern-regina-north/",
    "leopolds-tavern-regina-east": "https://iorders-restaurant-online-dev.pages.dev/leopolds-tavern-regina-east/",
    "leopolds-tavern-regina-albert": "https://iorders-restaurant-online-dev.pages.dev/leopolds-tavern-regina-albert/",
    "leopolds-tavern-regina-south": "https://iorders-restaurant-online-dev.pages.dev/leopolds-tavern-regina-south/",
  };

  return linkMap[title] || "N/A";
}

// ... rest of the code remains unchanged
const storeDetails = {
  status: "success",
  data: {
    restaurants: [
      // ===== ORDER ONLINE AVAILABLE =====


      //1. Leopold's Tavern Calgary Bowness
      {
        profile: {
          id: 1005,
          restaurant_name: "Leopold's Tavern Calgary Bowness",
          title: "leopolds-tavern-calgary-bowness",
          address: "6512 Bowness Road NW, Calgary, AB T3B 0E9, Canada",
          phone: "+1 (855) 522-5367",
          available_days: [
            { id: 10051, day: "SUNDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10052, day: "MONDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10053, day: "MONDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10054, day: "TUESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10055, day: "TUESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10056, day: "WEDNESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10057, day: "WEDNESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10058, day: "THURSDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10059, day: "THURSDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 100510, day: "FRIDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 100511, day: "FRIDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 100512, day: "SATURDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 100513, day: "SATURDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 100514, day: "SUNDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
          ],
          close_restaurent: false,
          lat: "51.082490",
          lng: "-114.191580",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },


      //2. Leopold's Tavern Calgary Sage Hill
      {
        profile: {
          id: 1007,
          restaurant_name: "Leopold's Tavern Calgary Sage Hill",
          title: "leopolds-tavern-calgary-sage-hill",
          address: "302 Sage Valley Common NW, Calgary, AB T3R 1T8, Canada",
          phone: "+1 (855) 522-5367",
          available_days: [
            { id: 10071, day: "SUNDAY", opening_time: "10:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10072, day: "MONDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10073, day: "TUESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10074, day: "WEDNESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10075, day: "THURSDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10076, day: "FRIDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10077, day: "SATURDAY", opening_time: "00:00:00", closing_time: "01:00:00", order_mode: 1 },
            { id: 10078, day: "SATURDAY", opening_time: "10:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10079, day: "SUNDAY", opening_time: "00:00:00", closing_time: "01:00:00", order_mode: 1 },
          ],
          close_restaurent: false,
          lat: "51.172480",
          lng: "-114.088560",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },


      //3. Leopold's Tavern Edmonton Strathcona
      {
        profile: {
          id: 1012,
          restaurant_name: "Leopold's Tavern Edmonton Strathcona",
          title: "leopolds-tavern-edmonton-strathcona",
          address: "10302 82 Avenue NW, Edmonton, AB T6E 1Z8, Canada",
          phone: "+1 (855) 522-5367",
          available_days: [
            { id: 10121, day: "SUNDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10122, day: "MONDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10123, day: "MONDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10124, day: "TUESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10125, day: "TUESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10126, day: "WEDNESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10127, day: "WEDNESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10128, day: "THURSDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10129, day: "THURSDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 101210, day: "FRIDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 101211, day: "FRIDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 101212, day: "SATURDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 101213, day: "SATURDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 101214, day: "SUNDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
          ],
          close_restaurent: false,
          lat: "53.519090",
          lng: "-113.497800",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },



      //4. Leopold's Tavern Regina Albert (OG)
      {
        profile: {
          id: 1013,
          restaurant_name: "Leopold's Tavern Regina Albert",
          title: "leopolds-tavern-regina-albert",
          address: "2330 Albert Street, Regina, SK S4P 2V7, Canada",
          phone: "+1 (306) 525-5367",
          available_days: [
            { id: 10131, day: "SUNDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10132, day: "MONDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10133, day: "MONDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10134, day: "TUESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10135, day: "TUESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10136, day: "WEDNESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10137, day: "WEDNESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10138, day: "THURSDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10139, day: "THURSDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 101310, day: "FRIDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 101311, day: "FRIDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 101312, day: "SATURDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 101313, day: "SATURDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 101314, day: "SUNDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
          ],
          close_restaurent: false,
          lat: "50.441670",
          lng: "-104.618330",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },


      //5. Leopold's Tavern Regina East
      {
        profile: {
          id: 1014,
          restaurant_name: "Leopold's Tavern Regina East",
          title: "leopolds-tavern-regina-east",
          address: "3735 East Quance Street, Regina, SK S4V 3A4, Canada",
          phone: "+1 (306) 559-5367",
          available_days: [
            { id: 10141, day: "SUNDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10142, day: "MONDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10143, day: "MONDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10144, day: "TUESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10145, day: "TUESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10146, day: "WEDNESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10147, day: "WEDNESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10148, day: "THURSDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10149, day: "THURSDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 101410, day: "FRIDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 101411, day: "FRIDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 101412, day: "SATURDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 101413, day: "SATURDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 101414, day: "SUNDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
          ],
          close_restaurent: false,
          lat: "50.432210",
          lng: "-104.539510",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },


      //6. Leopold's Tavern Regina North
      {
        profile: {
          id: 1015,
          restaurant_name: "Leopold's Tavern Regina North",
          title: "leopolds-tavern-regina-north",
          address: "5650 Rochdale Boulevard, Regina, SK S4X 4P1, Canada",
          phone: "+1 (855) 522-5367",
          available_days: [
            { id: 10151, day: "SUNDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10152, day: "MONDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10153, day: "MONDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10154, day: "TUESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10155, day: "TUESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10156, day: "WEDNESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10157, day: "WEDNESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10158, day: "THURSDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10159, day: "THURSDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 101510, day: "FRIDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 101511, day: "FRIDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 101512, day: "SATURDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 101513, day: "SATURDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 101514, day: "SUNDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
          ],
          close_restaurent: false,
          lat: "50.493630",
          lng: "-104.636380",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },


      //7. Leopold's Tavern Regina South
      {
        profile: {
          id: 1016,
          restaurant_name: "Leopold's Tavern Regina South",
          title: "leopolds-tavern-regina-south",
          address: "4529 Gordon Road, Regina, SK S4W 0B7, Canada",
          phone: "+1 (855) 522-5367",
          available_days: [
            { id: 10161, day: "SUNDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10162, day: "MONDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10163, day: "MONDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10164, day: "TUESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10165, day: "TUESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10166, day: "WEDNESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10167, day: "WEDNESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10168, day: "THURSDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10169, day: "THURSDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 101610, day: "FRIDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 101611, day: "FRIDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 101612, day: "SATURDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 101613, day: "SATURDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 101614, day: "SUNDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
          ],
          close_restaurent: false,
          lat: "50.390250",
          lng: "-104.637800",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },


      //8. Leopold's Tavern Saskatoon Broadway
      {
        profile: {
          id: 1017,
          restaurant_name: "Leopold's Tavern Saskatoon Broadway",
          title: "leopolds-tavern-saskatoon-broadway",
          address: "616 10 Street East, Saskatoon, SK S7H 0G9, Canada",
          phone: "+1 (306) 954-5367",
          available_days: [
            { id: 10171, day: "SUNDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10172, day: "MONDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10173, day: "MONDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10174, day: "TUESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10175, day: "TUESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10176, day: "WEDNESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10177, day: "WEDNESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10178, day: "THURSDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10179, day: "THURSDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 101710, day: "FRIDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 101711, day: "FRIDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 101712, day: "SATURDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 101713, day: "SATURDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 101714, day: "SUNDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
          ],
          close_restaurent: false,
          lat: "52.130870",
          lng: "-106.634500",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },


      //9. Leopold's Tavern Saskatoon Evergreen
      {
        profile: {
          id: 1018,
          restaurant_name: "Leopold's Tavern Saskatoon Evergreen",
          title: "leopolds-tavern-saskatoon-evergreen",
          address: "211 Evergreen Square, Saskatoon, SK S7W 0X2, Canada",
          phone: "+1 (306) 974-5367",
          available_days: [
            { id: 10181, day: "SUNDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10182, day: "MONDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10183, day: "MONDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10184, day: "TUESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10185, day: "TUESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10186, day: "WEDNESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10187, day: "WEDNESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10188, day: "THURSDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10189, day: "THURSDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 101810, day: "FRIDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 101811, day: "FRIDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 101812, day: "SATURDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 101813, day: "SATURDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 101814, day: "SUNDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
          ],
          close_restaurent: false,
          lat: "52.064980",
          lng: "-106.710520",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },

      // ===== OTHER LOCATIONS =====



      //10. Leopold's Tavern Kelowna
      {
        profile: {
          id: 1001,
          restaurant_name: "Leopold's Tavern Kelowna",
          title: "leopolds-tavern-kelowna",
          address: "279 Bernard Avenue, Kelowna, BC V1Y 6N2, Canada",
          phone: "+1 (855) 522-5367",
          available_days: [
            { id: 10011, day: "SUNDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10012, day: "MONDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10013, day: "MONDAY", opening_time: "12:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10014, day: "TUESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10015, day: "TUESDAY", opening_time: "12:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10016, day: "WEDNESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10017, day: "WEDNESDAY", opening_time: "12:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10018, day: "THURSDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10019, day: "THURSDAY", opening_time: "12:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 100110, day: "FRIDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 100111, day: "FRIDAY", opening_time: "12:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 100112, day: "SATURDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 100113, day: "SATURDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 100114, day: "SUNDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
          ],
          close_restaurent: false,
          lat: "49.887757",
          lng: "-119.496049",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },


      //11. Leopold's Tavern Vancouver
      {
        profile: {
          id: 1002,
          restaurant_name: "Leopold's Tavern Vancouver",
          title: "leopolds-tavern-vancouver",
          address: "1619 West Broadway, Vancouver, BC V6J 1W9, Canada",
          phone: "+1 (855) 522-5367",
          available_days: [
            { id: 10021, day: "SUNDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10022, day: "MONDAY", opening_time: "00:00:00", closing_time: "01:00:00", order_mode: 1 },
            { id: 10023, day: "MONDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10024, day: "TUESDAY", opening_time: "00:00:00", closing_time: "01:00:00", order_mode: 1 },
            { id: 10025, day: "TUESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10026, day: "WEDNESDAY", opening_time: "00:00:00", closing_time: "01:00:00", order_mode: 1 },
            { id: 10027, day: "WEDNESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10028, day: "THURSDAY", opening_time: "00:00:00", closing_time: "01:00:00", order_mode: 1 },
            { id: 10029, day: "THURSDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 100210, day: "FRIDAY", opening_time: "00:00:00", closing_time: "01:00:00", order_mode: 1 },
            { id: 100211, day: "FRIDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 100212, day: "SATURDAY", opening_time: "00:00:00", closing_time: "01:00:00", order_mode: 1 },
            { id: 100213, day: "SATURDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 100214, day: "SUNDAY", opening_time: "00:00:00", closing_time: "01:00:00", order_mode: 1 },
          ],
          close_restaurent: false,
          lat: "49.263330",
          lng: "-123.138020",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },


      //12. Leopold's Tavern Victoria
      {
        profile: {
          id: 1003,
          restaurant_name: "Leopold's Tavern Victoria",
          title: "leopolds-tavern-victoria",
          address: "570 Yates Street, Victoria, BC V8W 1K8, Canada",
          phone: "+1 (855) 522-5367",
          available_days: [
            { id: 10031, day: "SUNDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10032, day: "MONDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10033, day: "TUESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10034, day: "WEDNESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10035, day: "THURSDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10036, day: "FRIDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10037, day: "SATURDAY", opening_time: "00:00:00", closing_time: "01:00:00", order_mode: 1 },
            { id: 10038, day: "SATURDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10039, day: "SUNDAY", opening_time: "00:00:00", closing_time: "01:00:00", order_mode: 1 },
          ],
          close_restaurent: false,
          lat: "48.424700",
          lng: "-123.366300",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },



      //13. Leopold's Tavern Calgary Beltline
      {
        profile: {
          id: 1004,
          restaurant_name: "Leopold's Tavern Calgary Beltline",
          title: "leopolds-tavern-calgary-beltline",
          address: "1201 1 Street SW, Calgary, AB T2R 0V3, Canada",
          phone: "+1 (587) 350-5367",
          available_days: [
            { id: 10041, day: "SUNDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10042, day: "MONDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10043, day: "MONDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10044, day: "TUESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10045, day: "TUESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10046, day: "WEDNESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10047, day: "WEDNESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10048, day: "THURSDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10049, day: "THURSDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 100410, day: "FRIDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 100411, day: "FRIDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 100412, day: "SATURDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 100413, day: "SATURDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 100414, day: "SUNDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
          ],
          close_restaurent: false,
          lat: "51.044220",
          lng: "-114.071930",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },


      //14. Leopold's Tavern Calgary Elbow
      {
        profile: {
          id: 1006,
          restaurant_name: "Leopold's Tavern Calgary Elbow",
          title: "leopolds-tavern-calgary-elbow",
          address: "7746 Elbow Drive SW, Calgary, AB T2V 1K2, Canada",
          phone: "+1 (855) 522-5367",
          available_days: [
            { id: 10061, day: "SUNDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10062, day: "MONDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10063, day: "MONDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10064, day: "TUESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10065, day: "TUESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10066, day: "WEDNESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10067, day: "WEDNESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10068, day: "THURSDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10069, day: "THURSDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 100610, day: "FRIDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 100611, day: "FRIDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 100612, day: "SATURDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 100613, day: "SATURDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 100614, day: "SUNDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
          ],
          close_restaurent: false,
          lat: "50.970390",
          lng: "-114.084870",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },


      //15. Leopold's Tavern Calgary Seton
      {
        profile: {
          id: 1008,
          restaurant_name: "Leopold's Tavern Calgary Seton",
          title: "leopolds-tavern-calgary-seton",
          address: "4025 Market Street SE, Calgary, AB T3M 1M4, Canada",
          phone: "+1 (855) 522-5367",
          available_days: [
            { id: 10081, day: "SUNDAY", opening_time: "09:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10082, day: "MONDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10083, day: "MONDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10084, day: "TUESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10085, day: "TUESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10086, day: "WEDNESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10087, day: "WEDNESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10088, day: "THURSDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10089, day: "THURSDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 100810, day: "FRIDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 100811, day: "FRIDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 100812, day: "SATURDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 100813, day: "SATURDAY", opening_time: "09:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 100814, day: "SUNDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
          ],
          close_restaurent: false,
          lat: "50.876220",
          lng: "-113.969450",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },


      //16. Leopold's Tavern Okotoks
      {
        profile: {
          id: 1009,
          restaurant_name: "Leopold's Tavern Okotoks",
          title: "leopolds-tavern-okotoks",
          address: "10 D'Arcy Ranch Drive, Okotoks, AB T1S 5V9, Canada",
          phone: "+1 (855) 522-5367",
          available_days: [
            { id: 10091, day: "SUNDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10092, day: "MONDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10093, day: "MONDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10094, day: "TUESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10095, day: "TUESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10096, day: "WEDNESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10097, day: "WEDNESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10098, day: "THURSDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10099, day: "THURSDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 100910, day: "FRIDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 100911, day: "FRIDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 100912, day: "SATURDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 100913, day: "SATURDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 100914, day: "SUNDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
          ],
          close_restaurent: false,
          lat: "50.726620",
          lng: "-113.983860",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },


      //17. Leopold's Tavern Edmonton Heritage Valley
      {
        profile: {
          id: 1010,
          restaurant_name: "Leopold's Tavern Edmonton Heritage Valley",
          title: "leopolds-tavern-edmonton-heritage-valley",
          address: "2861 119A Street SW, Edmonton, AB T6W 0X1, Canada",
          phone: "+1 (855) 522-5367",
          available_days: [
            { id: 10101, day: "SUNDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10102, day: "MONDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10103, day: "MONDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10104, day: "TUESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10105, day: "TUESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10106, day: "WEDNESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10107, day: "WEDNESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10108, day: "THURSDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10109, day: "THURSDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 101010, day: "FRIDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 101011, day: "FRIDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 101012, day: "SATURDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 101013, day: "SATURDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 101014, day: "SUNDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
          ],
          close_restaurent: false,
          lat: "53.399820",
          lng: "-113.617430",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },


      //18. Leopold's Tavern Edmonton Orchards
      {
        profile: {
          id: 1011,
          restaurant_name: "Leopold's Tavern Edmonton Orchards",
          title: "leopolds-tavern-edmonton-orchards",
          address: "2580 66 Street SW, Edmonton, AB T6X 1A3, Canada",
          phone: "+1 (855) 522-5367",
          available_days: [
            { id: 10111, day: "SUNDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10112, day: "MONDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10113, day: "MONDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10114, day: "TUESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10115, day: "TUESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10116, day: "WEDNESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10117, day: "WEDNESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10118, day: "THURSDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10119, day: "THURSDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 101110, day: "FRIDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 101111, day: "FRIDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 101112, day: "SATURDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 101113, day: "SATURDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 101114, day: "SUNDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
          ],
          close_restaurent: false,
          lat: "53.408010",
          lng: "-113.401460",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },


      //19. Leopold's Tavern Saskatoon Kensington
      {
        profile: {
          id: 1019,
          restaurant_name: "Leopold's Tavern Saskatoon Kensington",
          title: "leopolds-tavern-saskatoon-kensington",
          address: "149 Kensington Boulevard Unit 10, Saskatoon, SK S7L 6V7, Canada",
          phone: "+1 (855) 522-5367",
          available_days: [
            { id: 10191, day: "SUNDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10192, day: "MONDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10193, day: "MONDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10194, day: "TUESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10195, day: "TUESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10196, day: "WEDNESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10197, day: "WEDNESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10198, day: "THURSDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10199, day: "THURSDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 101910, day: "FRIDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 101911, day: "FRIDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 101912, day: "SATURDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 101913, day: "SATURDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 101914, day: "SUNDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
          ],
          close_restaurent: false,
          lat: "52.184400",
          lng: "-106.714000",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },


      //20. Leopold's Tavern Saskatoon Rosewood
      {
        profile: {
          id: 1020,
          restaurant_name: "Leopold's Tavern Saskatoon Rosewood",
          title: "leopolds-tavern-saskatoon-rosewood",
          address: "120 Tweed Lane, Saskatoon, SK S7V 0A7, Canada",
          phone: "+1 (306) 974-2739",
          available_days: [
            { id: 10201, day: "SUNDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10202, day: "MONDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10203, day: "MONDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10204, day: "TUESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10205, day: "TUESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10206, day: "WEDNESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10207, day: "WEDNESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10208, day: "THURSDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10209, day: "THURSDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 102010, day: "FRIDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 102011, day: "FRIDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 102012, day: "SATURDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 102013, day: "SATURDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 102014, day: "SUNDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
          ],
          close_restaurent: false,
          lat: "52.065420",
          lng: "-106.553870",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },


      //21. Leopold's Tavern Warman
      {
        profile: {
          id: 1021,
          restaurant_name: "Leopold's Tavern Warman",
          title: "leopolds-tavern-warman",
          address: "910 Centennial Boulevard, Warman, SK S0K 4S1, Canada",
          phone: "+1 (855) 522-5367",
          available_days: [
            { id: 10211, day: "SUNDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10212, day: "MONDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10213, day: "TUESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10214, day: "WEDNESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10215, day: "THURSDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10216, day: "FRIDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10217, day: "SATURDAY", opening_time: "00:00:00", closing_time: "01:00:00", order_mode: 1 },
            { id: 10218, day: "SATURDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10219, day: "SUNDAY", opening_time: "00:00:00", closing_time: "01:00:00", order_mode: 1 },
          ],
          close_restaurent: false,
          lat: "52.319060",
          lng: "-106.576830",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },



      //22. Leopold's Tavern Winnipeg Academy
      {
        profile: {
          id: 1022,
          restaurant_name: "Leopold's Tavern Winnipeg Academy",
          title: "leopolds-tavern-winnipeg-academy",
          address: "414 Academy Road, Winnipeg, MB R3N 0B9, Canada",
          phone: "+1 (855) 522-5367",
          available_days: [
            { id: 10221, day: "SUNDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10222, day: "MONDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10223, day: "MONDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10224, day: "TUESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10225, day: "TUESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10226, day: "WEDNESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10227, day: "WEDNESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10228, day: "THURSDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10229, day: "THURSDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 102210, day: "FRIDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 102211, day: "FRIDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 102212, day: "SATURDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 102213, day: "SATURDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 102214, day: "SUNDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
          ],
          close_restaurent: false,
          lat: "49.872980",
          lng: "-97.182970",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },


      //23. Leopold's Tavern Winnipeg Bridgwater
      {
        profile: {
          id: 1023,
          restaurant_name: "Leopold's Tavern Winnipeg Bridgwater",
          title: "leopolds-tavern-winnipeg-bridgwater",
          address: "350 North Town Road Unit 340, Winnipeg, MB R3Y 1G5, Canada",
          phone: "+1 (855) 522-5367",
          available_days: [
            { id: 10231, day: "SUNDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10232, day: "MONDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10233, day: "MONDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10234, day: "TUESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10235, day: "TUESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10236, day: "WEDNESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10237, day: "WEDNESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10238, day: "THURSDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10239, day: "THURSDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 102310, day: "FRIDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 102311, day: "FRIDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 102312, day: "SATURDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 102313, day: "SATURDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 102314, day: "SUNDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
          ],
          close_restaurent: false,
          lat: "49.799200",
          lng: "-97.201700",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },


      //24. Leopold's Tavern Winnipeg Henderson
      {
        profile: {
          id: 1024,
          restaurant_name: "Leopold's Tavern Winnipeg Henderson",
          title: "leopolds-tavern-winnipeg-henderson",
          address: "1347 Henderson Highway, Winnipeg, MB R2G 1M5, Canada",
          phone: "+1 (855) 522-5367",
          available_days: [
            { id: 10241, day: "SUNDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10242, day: "MONDAY", opening_time: "00:00:00", closing_time: "01:00:00", order_mode: 1 },
            { id: 10243, day: "MONDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10244, day: "TUESDAY", opening_time: "00:00:00", closing_time: "01:00:00", order_mode: 1 },
            { id: 10245, day: "TUESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10246, day: "WEDNESDAY", opening_time: "00:00:00", closing_time: "01:00:00", order_mode: 1 },
            { id: 10247, day: "WEDNESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10248, day: "THURSDAY", opening_time: "00:00:00", closing_time: "01:00:00", order_mode: 1 },
            { id: 10249, day: "THURSDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 102410, day: "FRIDAY", opening_time: "00:00:00", closing_time: "01:00:00", order_mode: 1 },
            { id: 102411, day: "FRIDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 102412, day: "SATURDAY", opening_time: "00:00:00", closing_time: "01:00:00", order_mode: 1 },
            { id: 102413, day: "SATURDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 102414, day: "SUNDAY", opening_time: "00:00:00", closing_time: "01:00:00", order_mode: 1 },
          ],
          close_restaurent: false,
          lat: "49.917360",
          lng: "-97.093870",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },


      //25. Leopold's Tavern Winnipeg Osborne South
      {
        profile: {
          id: 1025,
          restaurant_name: "Leopold's Tavern Winnipeg Osborne South",
          title: "leopolds-tavern-winnipeg-osborne-south",
          address: "696 Osborne Street, Winnipeg, MB R3L 2B9, Canada",
          phone: "+1 (855) 522-5367",
          available_days: [
            { id: 10251, day: "SUNDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10252, day: "MONDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10253, day: "MONDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10254, day: "TUESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10255, day: "TUESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10256, day: "WEDNESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10257, day: "WEDNESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10258, day: "THURSDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10259, day: "THURSDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 102510, day: "FRIDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 102511, day: "FRIDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 102512, day: "SATURDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 102513, day: "SATURDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 102514, day: "SUNDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
          ],
          close_restaurent: false,
          lat: "49.868620",
          lng: "-97.148470",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },


      //26. Leopold's Tavern Winnipeg Osborne Village
      {
        profile: {
          id: 1026,
          restaurant_name: "Leopold's Tavern Winnipeg Osborne Village",
          title: "leopolds-tavern-winnipeg-osborne-village",
          address: "93 Osborne Street, Winnipeg, MB R3L 1Y4, Canada",
          phone: "+1 (855) 522-5367",
          available_days: [
            { id: 10261, day: "SUNDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10262, day: "MONDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10263, day: "MONDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10264, day: "TUESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10265, day: "TUESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10266, day: "WEDNESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10267, day: "WEDNESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10268, day: "THURSDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10269, day: "THURSDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 102610, day: "FRIDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 102611, day: "FRIDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 102612, day: "SATURDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 102613, day: "SATURDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 102614, day: "SUNDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
          ],
          close_restaurent: false,
          lat: "49.875510",
          lng: "-97.147780",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },


      //27. Leopold's Tavern Winnipeg Sage Creek
      {
        profile: {
          id: 1027,
          restaurant_name: "Leopold's Tavern Winnipeg Sage Creek",
          title: "leopolds-tavern-winnipeg-sage-creek",
          address: "107 Burning Glass Road, Winnipeg, MB R3X 0K6, Canada",
          phone: "+1 (855) 522-5367",
          available_days: [
            { id: 10271, day: "SUNDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10272, day: "MONDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10273, day: "MONDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10274, day: "TUESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10275, day: "TUESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10276, day: "WEDNESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10277, day: "WEDNESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10278, day: "THURSDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10279, day: "THURSDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 102710, day: "FRIDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 102711, day: "FRIDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 102712, day: "SATURDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 102713, day: "SATURDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 102714, day: "SUNDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
          ],
          close_restaurent: false,
          lat: "49.808380",
          lng: "-97.049600",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },


      //28. Leopold's Tavern Winnipeg Transcona
      {
        profile: {
          id: 1028,
          restaurant_name: "Leopold's Tavern Winnipeg Transcona",
          title: "leopolds-tavern-winnipeg-transcona",
          address: "1520 Plessis Road, Winnipeg, MB R2C 5G6, Canada",
          phone: "+1 (855) 522-5367",
          available_days: [
            { id: 10281, day: "SUNDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10282, day: "MONDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10283, day: "MONDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10284, day: "TUESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10285, day: "TUESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10286, day: "WEDNESDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10287, day: "WEDNESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 10288, day: "THURSDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 10289, day: "THURSDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 102810, day: "FRIDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 102811, day: "FRIDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 102812, day: "SATURDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
            { id: 102813, day: "SATURDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 102814, day: "SUNDAY", opening_time: "00:00:00", closing_time: "02:00:00", order_mode: 1 },
          ],
          close_restaurent: false,
          lat: "49.903470",
          lng: "-97.011430",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },

    ],
  },
  message: "successful response",
};

export default storeDetails;
